import { render, staticRenderFns } from "./component-ai.vue?vue&type=template&id=f1589436&"
import script from "./component-ai.vue?vue&type=script&lang=js&"
export * from "./component-ai.vue?vue&type=script&lang=js&"
import style0 from "./component-ai.vue?vue&type=style&index=0&id=f1589436&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports